<div class="projects__search ph-input">
  <app-ph-input
    [placeholder]="!placeholder ? ('PROJECTS.search_project' | translate) : placeholder"
    [validation]="'base'"
    type="text"
    [autocomplete]="false"
    [correctForm]="correctForm"
    [icon]="'search-primary'"
    [autoFocus]="searchAutoFocus"
    #searchInput
    ngDefaultControl
    name="search"
    (phInputChange)="onSearch($event)"
  ></app-ph-input>
</div>
